<template>
  <div class="login">
    <div class="phone-change" v-if="login">
      <div
        class="left"
        @click="changePhone()"
        :class="{ active: activeName === 'phone' }"
      >
        手机号登录
        <Transition name="fade">
          <div
            v-if="activeName === 'phone'"
            :class="{ active: activeName === 'phone' }"
            class="line"
          >
            <i class="table-line"></i>
          </div>
        </Transition>
      </div>
      <div
        class="right"
        @click="changePwd()"
        :class="{ active: activeName === 'code' }"
      >
        账号密码登录
        <Transition name="fade">
          <div
            v-if="activeName === 'code'"
            :class="{ active: activeName === 'code' }"
            class="line"
          >
            <i class="table-line"></i>
          </div>
        </Transition>
      </div>
    </div>
    <!-- 手机号验证码登录 -->
    <Form
      ref="phoneLogin"
      v-show="activeName === 'phone'"
      class="phone-code"
      :validation-schema="schema"
      v-slot="{ errors }"
    >
      <div class="input-box">
        <div class="input-item">
          <i style="margin-left: 15px" class="iconfont icon-shouji"></i>
          <Field
            v-model="form.phone"
            name="phone"
            class="input"
            type="text"
            placeholder="请输入手机号码"
          />
        </div>
        <div v-show="errors.phone" class="error-box">
          <i style="margin-left: 15px" class="iconfont icon-tishi"></i>
          {{ errors.phone }}
        </div>
      </div>
      <div class="input-msg">
        <div class="input-item">
          <div class="input-code">
            <i
              style="margin-left: 15px"
              class="iconfont icon-anquandengji1"
            ></i>
            <Field
              v-model="form.code"
              name="code"
              class="input"
              type="text"
              placeholder="请输入短信验证码"
            />
            <div class="code-msg">
              <div v-if="msg" @click="getCode" class="get-code">
                <span>获取验证码</span>
              </div>
              <div v-else class="get-code-msg">
                <span>{{ second }}s后重新发送</span>
              </div>
            </div>
          </div>
        </div>
        <div v-show="errors.code" class="error-box">
          <i style="margin-left: 15px" class="iconfont icon-tishi"></i>
          {{ errors.code }}
        </div>
      </div>
      <div class="reg-notice">未注册山河医考网站的手机号，登录将自动注册</div>
      <div class="loging">
        <el-button @click="codeLogin" size="large" type="primary"
          >立即登录</el-button
        >
      </div>
    </Form>
    <!-- 账号密码登录 -->
    <Form
      ref="accountLogin"
      v-show="activeName === 'code'"
      class="phone-pwd"
      :validation-schema="schema"
      v-slot="{ errors }"
    >
      <div class="input-box">
        <div class="input-item">
          <i style="margin-left: 15px" class="iconfont icon-shouji"></i>
          <Field
            v-model="form.account"
            name="account"
            type="text"
            class="input"
            placeholder="请输入手机号码"
          />
        </div>
        <div v-show="errors.account" class="error-box">
          <i style="margin-left: 15px" class="iconfont icon-tishi"></i>
          {{ errors.account }}
        </div>
      </div>
      <div class="pwd-box">
        <div class="input-item">
          <i style="margin-left: 15px" class="iconfont icon-jiesuo"></i>
          <Field
            v-model="form.password"
            name="password"
            v-if="eye"
            type="password"
            class="input"
            placeholder="请输入密码"
          />
          <Field
            name="password"
            v-else
            type="text"
            v-model="form.password"
            class="input"
            placeholder="请输入密码"
          />
          <div @click="eyeLock" class="lock-pwd">
            <i
              v-if="eye"
              style="
                margin-right: 15px;
                cursor: pointer;
                width: 18px;
                height: 18px;
              "
              class="iconfont icon-biyanjing"
            ></i>
            <i
              v-else
              style="
                margin-right: 15px;
                cursor: pointer;
                width: 18px;
                height: 18px;
              "
              class="iconfont icon-yanjing"
            ></i>
          </div>
        </div>
        <div v-show="errors.password" class="error-box">
          <i style="margin-left: 15px" class="iconfont icon-tishi"></i>
          {{ errors.password }}
        </div>
      </div>
      <div class="reg-box">
        <!-- <RouterLink to="/user/register">
          <div class="reg-free">免费注册</div>
        </RouterLink> -->
        <div @click="register()" class="reg-free">免费注册</div>
        <div class="line"></div>
        <RouterLink to="/user/getpwd">
          <div class="lost">忘记密码</div>
        </RouterLink>
      </div>
      <div class="loging">
        <el-button @click="pwdLogin" size="large" type="primary"
          >立即登录</el-button
        >
      </div>
    </Form>
    <!-- 点击登录 -->
    <div v-show="activeName === 'register'" class="register">
      <Register @goLogin="goLogin" :checked="checked" />
      <!-- <div @click="goLogin()" class="go-login">
        已有账号？<span>去登陆</span>
      </div> -->
    </div>
    <div class="agree-tips">
      <div class="tip">
        <div v-show="!checked" class="tip-item">
          <el-tag>请阅读并勾选</el-tag>
        </div>
      </div>
      <div class="check-list">
        <el-checkbox v-model="checked"></el-checkbox>
        <span
          >我已阅读并同意 <a href="javascript:;">《隐私政策》</a> 和
          <a href="javascript:;">《用户注册协议》</a>
        </span>
      </div>
    </div>

    <div @click="changeWeiLogin" class="wei-log">
      <img src="../../../public/icon/微信.png" alt="" />
      <h2>微信登录</h2>
    </div>
  </div>
</template>

<script>
import { useIntervalFn } from "@vueuse/core";
import { ElMessage } from "element-plus";
import { Form, Field } from "vee-validate";
import { ref, reactive, onMounted, onUnmounted } from "vue";
import loginSchema from "@/utils/login-validate";
import { useStore } from "vuex";
import Register from "@/components/library/sh-register";
import { useAccountLogin, usePhoneLogin, sendPhoneCode } from "@/api/user";
export default {
  name: "PhoneLogin",
  components: {
    Form,
    Field,
    Register,
  },
  setup(props, { emit }) {
    //表单数据对象
    const form = reactive({
      account: null,
      password: null,
      phone: null,
      code: null,
      errorBox: true,
    });
    const store = useStore();
    const login = ref(true);
    const phoneLogin = ref(null);
    const accountLogin = ref(null);
    const activeName = ref("phone");
    //const code = ref(false);
    //检查隐私协议勾选
    const checked = ref(true);

    const msg = ref(true);
    //密码点击显示隐藏
    const eye = ref(true);
    const second = ref(0);
    //const password = ref();

    //切换到手机验证码登录 清空账号密码并清空对账号密码登录的验证
    const changePhone = () => {
      activeName.value = "phone";
      form.account = null;
      form.password = null;
      accountLogin.value.resetForm();
    };
    //切换到账号密码登录 并清空对手机号和手机验证码登录的验证
    const changePwd = () => {
      activeName.value = "code";
      form.phone = null;
      form.code = null;
      phoneLogin.value.resetForm();
    };
    const weiToPwd = () => {
      activeName.value = "code";
      login.value = true;
      //code.value = !code.value;
      //phone.value = !phone.value;
    };
    const weiToCode = () => {
      //code.value = !code.value;
      //phone.value = !phone.value;
      login.value = true;
      activeName.value = "phone";
    };
    const changeWeiLogin = () => {
      //phone.value = false;
      //code.value = false;
      emit("changeWei");
    };

    //获取验证码
    const { pause, resume } = useIntervalFn(
      () => {
        second.value--;
        if (second.value <= 0) {
          pause();
          msg.value = true;
        }
      },
      1000,
      false
    );
    const getCode = async () => {
      const valid = loginSchema.phone(form.phone);
      if (valid === true) {
        try {
          //验证通过发送短信验证码，弹出短信发送成功提示，开启倒计时
          //发送短信验证码
          const code = await sendPhoneCode(form.phone);
          //后台返回消息，提示验证码发送成功
          /* if (code) {
          ElMessage({
            message: "验证码发送成功",
            type: "success",
          });
        } */
          ElMessage({
            message: code.msg,
            type: "success",
          });
          /* if (code.status == 200) {
            ElMessage({
              message: code.msg,
              type: "success",
            });
          } */
          second.value = 60;
          resume();
          msg.value = false;
        } catch (error) {
          console.log(error);
        }
      } else {
        //验证失败 显示错误信息 setFiekdError(字段，错误信息)
        phoneLogin.value.setFieldError("phone", valid);
      }
    };

    //密码锁关闭睁开
    const eyeLock = () => {
      eye.value = !eye.value;
    };
    //手机号验证码登录
    const codeLogin = async () => {
      if (!checked.value) {
        ElMessage({
          message: "请勾选用户协议及隐私政策",
          type: "error",
        });
      } else {
        const valid = await phoneLogin.value.validate();
        if (valid) {
          const { phone, code } = form;
          usePhoneLogin({ phone, code })
            .then((data) => {
              // const { _id, image, phone,nickName, channel, token } = data.user;
              /*  store.commit("user/setUser", {
              _id,
              image,
              phone,
              nickname,
              token,
              channel
            }); */

              //提示登录成功
              if (data.code == 200) {
                ElMessage({
                  message: data.msg,
                  type: "success",
                });
                //储存登录信息
                const { _id, image, phone, nickName, channel, token, maID } =
                  data.user;
                store.commit("user/setUser", {
                  _id,
                  image,
                  phone,
                  nickName,
                  token,
                  channel,
                  maID,
                });
                //关闭登录框
                emit("changeVisible");
              } else {
                ElMessage({
                  message: data.msg,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              if (error.response.status == 422) {
                ElMessage({
                  message: error.response.data.msg,
                  type: "error",
                });
              } else {
                ElMessage({
                  message: error.message,
                  type: "error",
                });
              }
            });
        }
      }
    };
    //账号密码登录
    const pwdLogin = async () => {
      //点击登录之前对整体表单进行校验Form提供的validate函数，
      //返回promise函数，结果为true则表示校验通过

      if (!checked.value) {
        ElMessage({
          message: "请勾选用户协议及隐私政策",
          type: "error",
        });
      } else {
        const valid = await accountLogin.value.validate();
        if (valid) {
          const { account, password } = form;
          useAccountLogin({ account, password })
            .then((data) => {
              // const { _id, image, phone,nickName, channel, token } = data.user;
              /*  store.commit("user/setUser", {
              _id,
              image,
              phone,
              nickname,
              token,
              channel
            }); */

              //提示登录成功
              if (data.code == 200) {
                ElMessage({
                  message: data.msg,
                  type: "success",
                });
                //储存登录信息
                const { _id, image, phone, nickName, channel, token, maID } =
                  data.user;
                store.commit("user/setUser", {
                  _id,
                  image,
                  phone,
                  nickName,
                  token,
                  channel,
                  maID,
                });
                //关闭登录框
                emit("changeVisible");
              } else {
                ElMessage({
                  message: data.msg,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              if (error.response.status == 422) {
                ElMessage({
                  message: error.response.data.msg,
                  type: "error",
                });
              } else {
                ElMessage({
                  message: error.message,
                  type: "error",
                });
              }
            });
        }
      }
    };
    //从注册切换到账号密码登录
    const goLogin = () => {
      login.value = true;
      activeName.value = "code";
    };
    /* onMounted(() => {
      startCountdown();
    }); */
    //校验规则
    const schema = {
      account: loginSchema.account,
      password: loginSchema.password,
      phone: loginSchema.phone,
      code: loginSchema.code,
    };
    //点击注册按钮
    const register = () => {
      activeName.value = "register";
      login.value = false;
    };
    onUnmounted(() => {
      /* 这里为清除之前的倒计时函数
      if (intervalId) {
        clearInterval(intervalId);
      } */
      pause();
    });
    /*  defineExpose({
      changePwd,
    }); */
    return {
      checked,
      msg,
      second,
      eye,
      phoneLogin,
      accountLogin,
      activeName,
      //errorBox,
      login,
      form,
      schema,
      goLogin,
      register,
      changePwd,
      changePhone,
      pwdLogin,
      codeLogin,
      weiToPwd,
      weiToCode,
      eyeLock,
      changeWeiLogin,
      getCode,
    };
  },
};
</script>

<style lang="less" scoped>
.fade {
  &-leave {
    &-active {
      position: absolute;
      width: 100%;
      transition: opacity 0.01s 0.01s;
      z-index: 1;
    }
    &-to {
      opacity: 0;
    }
  }
}
.phone-code {
  margin-top: 20px;
  .input-box {
    width: 365px;
    height: 75px;
    .input-item {
      display: flex;
      align-items: center;
      //margin-bottom: 24px;
      box-sizing: border-box;
      width: 358px;
      height: 50px;
      opacity: 1;
      background-color: #f6f7f9;
      border-radius: 25px;
      outline: none;
      border: none;
      position: relative;
      .input {
        box-sizing: border-box;
        color: #333;
        padding: 0 8px;
        width: 356px;
        height: 48px;
        opacity: 1;
        font-size: 14px;
        background-color: #f6f7f9;
        border-radius: 25px;
        outline: none;
        border: none;
      }
    }
    .error-box {
      height: 24px;
      color: red;
    }
  }
  .input-msg {
    width: 365px;
    height: 75px;
    .input-item {
      /* display: flex;
      align-items: center; */
      //margin-bottom: 24px;
      box-sizing: border-box;
      width: 230px;
      height: 50px;
      opacity: 1;
      background-color: #f6f7f9;
      border-radius: 25px;
      outline: none;
      border: none;
      .input-code {
        display: flex;
        align-items: center;
        .input {
          box-sizing: border-box;
          color: #333;
          padding: 0 8px;
          width: 230px;
          height: 48px;
          opacity: 1;
          font-size: 14px;
          background-color: #f6f7f9;
          border-radius: 25px;
          outline: none;
          border: none;
        }
      }
    }
    .error-box {
      height: 24px;
      color: red;
    }
    .code-msg {
      padding-left: 45px;
      .get-code {
        color: #bfbfbf;
        box-sizing: border-box;
        width: 110px;
        height: 50px;
        border-radius: 25px;
        background-color: #409eff;
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center;
        color: #fff;
        cursor: pointer;
        border: none;
        font-size: 14px;
      }
      .get-code-msg {
        text-align: center;
        justify-content: center;
        align-items: center;
        color: #bfbfbf;
        box-sizing: border-box;
        width: 110px;
        height: 50px;
        border-radius: 25px;
        background-color: #f6f7f9;
        display: flex;
        color: #999;
        border: none;
        font-size: 14px;
        cursor: not-allowed;
      }
    }
  }
  .reg-notice {
    text-align: center;
    height: 21px;
    font-size: 12px;
    font-weight: 400;
    color: #9698a2;
    line-height: 21px;
    margin-bottom: 15px;
  }
}

.phone-pwd {
  margin-top: 20px;
  .input-box {
    width: 360px;
    height: 75px;
    .input-item {
      display: flex;
      align-items: center;

      box-sizing: border-box;
      width: 358px;
      height: 50px;
      opacity: 1;
      background-color: #f6f7f9;
      border-radius: 25px;
      outline: none;
      border: none;
      input {
        box-sizing: border-box;
        color: #333;
        padding: 0 8px;
        width: 356px;
        height: 48px;
        opacity: 1;
        font-size: 14px;
        background-color: #f6f7f9;
        border-radius: 25px;
        outline: none;
        border: none;
      }
    }
    .error-box {
      height: 24px;

      color: red;
    }
  }
  .pwd-box {
    width: 360px;
    height: 75px;
    .input-item {
      display: flex;
      align-items: center;
      //margin-bottom: 24px;
      box-sizing: border-box;
      width: 358px;
      height: 50px;
      opacity: 1;
      background-color: #f6f7f9;
      border-radius: 25px;
      outline: none;
      .input {
        box-sizing: border-box;
        color: #333;
        padding: 0 8px;
        width: 356px;
        height: 48px;
        opacity: 1;
        font-size: 14px;
        background-color: #f6f7f9;
        border-radius: 25px;
        outline: none;
        border: none;
      }
    }
    .error-box {
      height: 24px;
      color: red;
    }
  }
  .reg-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    width: 360px;
    height: 16px;
    margin-bottom: 20px;

    .reg-free {
      font-size: 14px;
      color: @shColor;
    }
    .lost {
      font-size: 14px;
      color: @shColor;
    }
    .line {
      margin: 0 12px;
      width: 1px;
      height: 16px;
      background: #c0c4cc;
      border-radius: 1px;
      line-height: 16px;
    }
  }
}
.login {
  .phone-change {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 360px;
    height: 40px;
    //margin: 0 auto;
    //background: #d18585;
    .left {
      width: 180px;
      height: 40px;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      & .active {
        color: @shColor;
      }
      .line {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        .table-line {
          display: block;
          //text-align: center;
          border-radius: 3px;
          width: 55px;
          margin-top: 5px;
          border: 3px solid @shColor;
        }
      }
      &:hover {
        cursor: pointer;
      }
    }
    .right {
      width: 180px;
      height: 40px;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      .line {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        .table-line {
          display: block;
          //text-align: center;
          width: 55px;
          margin-top: 5px;
          border-radius: 3px;
          border: 3px solid @shColor;
        }
      }
      &:hover {
        cursor: pointer;
      }
    }
    & .active {
      color: @shColor;
    }
  }

  .loging {
    display: flex;
    justify-content: center;
  }
  /* .register {
    
  } */
  .agree-tips {
    margin-top: 10px;
    height: 50px;
    .tip {
      height: 25px;
    }
    .check-list {
      display: flex;
      align-items: center;
      height: 32px;
      //margin-top: 15px;
      span {
        margin-left: 8px;
        a {
          color: @shColor;
        }
      }
    }
  }
  .wei-log {
    display: flex;
    height: 80px;
    justify-content: center;
    align-items: center;
    margin-top: 25px;
    border-top: 1px dashed #bfbfbf;
    & :hover {
      cursor: pointer;
    }
    img {
      width: 24px;
      height: 24px;
      margin-top: 2px;
      margin-right: 8px;
    }
  }
}
</style>
